export default __webpack_public_path__ + "static/media/t11.min.7a9c840b.png";